export var unique = function (item, index, items) { return items.indexOf(item) === index; };
export var getDifference = function (d1, d2) { return new Date(d1).getTime() - new Date(d2).getTime(); };
export var splitArrayIntoChunks = function (arr, chunkSize) {
    var chunks = [];
    var i = 0;
    while (i < arr.length) {
        chunks.push(arr.slice(i, (i += chunkSize)));
    }
    return chunks;
};
//# sourceMappingURL=index.js.map